import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DescriptionIcon from "@mui/icons-material/Description";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ProfileIcon from "@mui/icons-material/AccountCircle";

const Sidebar = ({ companyId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // Obter role do usuário
  const role = localStorage.getItem("role");

  // Definir itens visíveis com base no papel
  const sidebarItems = [
    {
      label: "Dashboard",
      path: `/company-dashboard/${companyId}`,
      icon: <DashboardIcon />,
      roles: ["admin", "recepcionista", "owner"],
    },
    {
      label: "Registros de Atendimento",
      path: `/company-appointments/${companyId}`,
      icon: <DescriptionIcon />,
      roles: ["admin", "recepcionista", "owner"],
    },
    {
      label: "Criar Setor",
      path: `/create-sector/${companyId}`,
      icon: <DomainAddIcon />,
      roles: ["admin", "owner"],
    },
    {
      label: "Criar Serviço",
      path: `/create-service/${companyId}`,
      icon: <HomeRepairServiceIcon />,
      roles: ["admin", "owner"],
    },
    {
      label: "Criar Atendimento",
      path: `/create-appointment/${companyId}`,
      icon: <AccessTimeFilledIcon />,
      roles: ["admin", "recepcionista", "owner"],
    },
    {
      label: "Reagendar Atendimento",
      path: `/reschedule-appointment/${companyId}`,
      icon: <AccountTreeIcon />,
      roles: ["admin", "recepcionista", "owner"],
    },
    {
      label: "Configurar Empresas",
      path: `/manage-companies/${companyId}`,
      icon: <ApartmentIcon />,
      roles: ["owner"],
    },
    {
      label: "Configurar Funcionários",
      path: `/manage-employees/${companyId}`,
      icon: <ProfileIcon />,
      roles: ["admin", "owner"],
    },
    {
      label: "Ajustes da Empresa",
      path: `/company-settings/${companyId}`,
      icon: <SettingsIcon />,
      roles: ["admin", "owner"],
    },
    {
      label: "Sair",
      path: "/logout",
      icon: <LogoutIcon />,
      roles: ["admin", "recepcionista", "owner"],
    },
  ];

  // Toggle Sidebar
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // Navegação
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box>
      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        open={isOpen}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        sx={{
          width: isOpen ? 240 : 60,
          transition: "width 0.3s",
          flexShrink: 0,
          zIndex: 1200,
          ".MuiDrawer-paper": {
            width: isOpen ? 240 : 60,
            overflowX: "hidden",
            transition: "width 0.3s",
            boxSizing: "border-box",
          },
        }}
      >
        <Box p={2} textAlign="center">
          <Typography variant="h6">Welcome!</Typography>
        </Box>

        <List>
          {sidebarItems
            .filter((item) => !item.roles || item.roles.includes(role))
            .map((item, index) => (
              <ListItem
                key={index}
                button
                sx={{ cursor: "pointer" }}
                onClick={() => handleNavigation(item.path)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                {isOpen && <ListItemText primary={item.label} />}
              </ListItem>
            ))}
        </List>
      </Drawer>
    </Box>
  );
};

export default Sidebar;
